// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21wC_","col":"styles_col__2Y4lK"};